/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DeadwoodRipGameAssets} from "./DeadwoodRipGameAssets";
import {DeadwoodRipSound} from "./sound/DeadwoodRipSound";
import {DeadwoodRipBackground} from "./view/DeadwoodRipBackground";
import {DeadwoodRipWinPresentation} from "./gameflow/DeadwoodRipWinPresentation";
import {DeadwoodRipNormalBetPresentation} from "./gameflow/DeadwoodRipNormalBetPresentation";
import {DeadwoodRipNormalResultPresentation} from "./gameflow/DeadwoodRipNormalResultPresentation";
import {DeadwoodRipNormalIdlePresentation} from "./gameflow/DeadwoodRipNormalIdlePresentation";
import {DeadwoodRipModel} from "./server/DeadwoodRipModel";
import {DeadwoodRipLayers} from "./view/DeadwoodRipLayers";
import {DeadwoodRipGameConfig} from "./DeadwoodRipGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {SymbolLandingController} from "./reelstoppresentation/presentations/SymbolLandingController";
import {S1LandingController} from "./reelstoppresentation/presentations/S1LandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {DeadwoodRipFreespinIdlePresentation} from "./gameflow/DeadwoodRipFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {WaysWonCountUp} from "./winpresentation/presentations/initial/WaysWonCountUp";
import {SymbolWinHighlightController} from "./reelstoppresentation/presentations/SymbolWinHighlightController";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {DeadwoodRipReelController} from "./reels/DeadwoodRipReelController";
import {XRipController} from "./winpresentation/presentations/XRipController";
import {DeadwoodRipLastReelController} from "./reels/DeadwoodRipLastReelController";
import {DisableLastReelController} from "./winpresentation/presentations/DisableLastReelController";
import {Multiplier} from "./view/Multiplier";
import {XBetController} from "./xbet/XBetController";
import {Ways} from "./view/Ways";
import {S1ToWRSTransformController} from "./winpresentation/presentations/S1ToWRSTransformController";
import {ReelSplitController} from "./winpresentation/presentations/ReelSplitController";
import {XSplitController} from "./winpresentation/presentations/XSplitController";
import {ShootingScreen} from "./view/shooting/ShootingScreen";
import {FreespinRetriggerController} from "./winpresentation/presentations/FreespinRetriggerController";
import {TotalMultiplierController} from "./winpresentation/presentations/TotalMultiplierController";
import {CylinderShotController} from "./winpresentation/presentations/CylinderShotController";
import {WinView} from "./winpresentation/WinView";
import {S3LandingController} from "./reelstoppresentation/presentations/S3LandingController";
import {LowToWildController} from "./winpresentation/presentations/LowToWildController";
import {IdleAnimationManager} from "./idle/IdleAnimationManager";
import {TumbleWeedController} from "./idle/animations/TumbleWeedController";
import {MainIdleDustController} from "./idle/animations/MainIdleDustController";
import {NearWinView} from "./view/NearWinView";
import {FreespinUpgradeController} from "./winpresentation/presentations/FreespinUpgradeController";
import {Skinner} from "./Skinner";
import {SkinLogo} from "./SkinLogo";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class DeadwoodRip extends SlotGame {

    public static model: DeadwoodRipModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static background: DeadwoodRipBackground;
    public static xBetController: XBetController;
    public static reels: DeadwoodRipReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static multiplier: Multiplier;
    public static initialCountUp: InitialWinCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static ways: Ways;
    public static waysWon: WaysWonCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winCapScreen: WinCapScreen;
    public static shootingScreen: ShootingScreen;
    public static playScattersWin: boolean = false;
    public static cylinderController: CylinderShotController;
    public static winView: WinView;
    public static idle: IdleAnimationManager;
    public static nearWinView: NearWinView;

    public static isActionSpinsActive: boolean = false;
    public static isSpinning: boolean = false;
    private static skinLogo: SkinLogo;
    private skinner: Skinner;

    constructor() {
        super();
        const validSkinIds: string[] = [
            "ug",
            "ozzo",
            "test",
            "bcgame",
            "sweep"
        ]
        this.skinner = new Skinner(validSkinIds);
    }

    public async init(): Promise<NolimitPlugin> {
        const value = await super.init();

        if (NolimitConfig.isDevMode) {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
        }
        (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;

        DeadwoodRipGameConfig.updateReelSets();
        DeadwoodRip.model = new DeadwoodRipModel(SlotGame.apiPlugin, true);
        DeadwoodRip.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DeadwoodRip.model);
        DeadwoodRip.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const normalIdle = new DeadwoodRipNormalIdlePresentation();
        const normalBet = new DeadwoodRipNormalBetPresentation();
        const normalResult = new DeadwoodRipNormalResultPresentation();
        const winPres = new DeadwoodRipWinPresentation();
        const freespinIdle = new DeadwoodRipFreespinIdlePresentation();

        DeadwoodRip.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, normalIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        DeadwoodRip.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        DeadwoodRip.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        this.handleSweepInit();
        return value;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(DeadwoodRipGameAssets.RESOURCES_GROUPS);
        DeadwoodRip.assetLoader = new AssetLoader(SlotGame.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("S1_overlay", "resources/images/S1_overlay.png");
        imgLoader.add("S2_overlay", "resources/images/S2_overlay.png");
        imgLoader.add("skinLogo", "resources/images/skinLogo.png");

        await Promise.all([fontLoader.load(), imgLoader.load(), DeadwoodRip.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.createViewsAndComponents();

        if (this.skinner.skinId != undefined) {
            //Source folder for skin assets e.g "resources/images/skinName";
            const assetPath: string = "resources/images/";
            const replaceMap: Map<string, string> = new Map();
            if (this.skinner.skinId === "sweep") {
                //Bonus
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
                replaceMap.set("Enhanced_Bet1", "Enhanced_Bet1.png");
                replaceMap.set("Enhanced_Bet2", "Enhanced_Bet2.png");
            } else {

                replaceMap.set("S1_overlay", "S1_overlay.png");
                replaceMap.set("S2_overlay", "S2_overlay.png");
                replaceMap.set("skinLogo", "skinLogo.png");

                //Bonus
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
                replaceMap.set("FREESPIN", "FREESPIN.png");
                replaceMap.set("SUPER_FREESPIN", "SUPER_FREESPIN.png");


                //Intro
                replaceMap.set("logo", "introLogo.png");
                replaceMap.set("fs", "FreespinPaytable.png");
                replaceMap.set("superfs", "SuperFreespin.png");
                replaceMap.set("split", "wilds.png");

                //AS
                replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");
            }
            await this.skinner.loadSkin(assetPath, replaceMap);
        }


        return value;
    }


    getPaytable(): Promise<string> {
        const data = {
            skinPath: "screens/images/",
            sweepPath: "",
        };

        if (this.skinner.skinId != undefined) {
            if (this.skinner.skinId === "sweep") {
                data.sweepPath = `../resources/images/${this.skinner.skinId}/`;
            } else {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
        }

        return super.getPaytable().then((value: string) => {
            if (this.skinner.skinId === "sweep") {
                value = value.replace(/{{skinPath}}{{sweepPath}}/g, data.sweepPath);
            }
            value = value.replace(/{{skinPath}}/g, data.skinPath);
            return value;
        });
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        DeadwoodRipSound.switchMusic(
            {name: DeadwoodRipSound.MAIN_GAME_MUSIC, volume: 0},
            {name: DeadwoodRipSound.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 1000}
        );

        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value = await super.start();

        this.restoreKeypadWin();
        DeadwoodRip.gameFlowController.start();
        DeadwoodRip.xBetController.start();
        // DeadwoodRipSound.switchMusic({name : DeadwoodRipSound.getMusicNameByMode(DeadwoodRip.model.data.mode)});

        return value;
    }

    getNoWinGameData(): any {
        return {
            "accumulatedRoundWin": 0,
            "betWayWins": [],
            "brokeTheBank": false,
            "bulletDataList": [],
            "enhancedBet": 0,
            "evaluatedArea": [
                ['M3', 'L4', 'L4'],
                ['L3', 'L1', 'L3', 'M2'],
                ['L4', 'M2', 'L2', 'L3'],
                ['M2', 'L2', 'L3', 'M4'],
                ['M1', 'M2']
            ],
            "freespinTriggeredThisSpin": false,
            "freespinsLeft": 0,
            "lowTransformList": [],
            "mode": "NORMAL",
            "multiplierFS": 1,
            "multiplierOnReels": [0, 0, 0, 0, 0],
            "nAdditionalFsAwarded": 0,
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "playedBetValue": 1,
            "reels": [
                ['M3', 'M3', 'L4', 'L4', 'M2'],
                ['L4', 'L3', 'L1', 'L3', 'M2', 'L4'],
                ['L3', 'L4', 'M2', 'L2', 'L3', 'M1'],
                ['L4', 'M2', 'L2', 'L3', 'M4', 'L2'],
                ['M1', 'M1', 'M2', 'M2']
            ],
            "scatterPositions": [-1, -1, -1, -1, -1],
            "symbolSizes": [
                [1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1]
            ],
            "totalSpinWinnings": 0,
            "wasFeatureBuy": false,
            "xRip": false
        };
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new DeadwoodRipSound();
        const layers = new DeadwoodRipLayers();

        //Views
        DeadwoodRip.shootingScreen = new ShootingScreen();
        DeadwoodRip.background = new DeadwoodRipBackground();
        DeadwoodRip.ways = new Ways();
        DeadwoodRip.multiplier = new Multiplier();
        DeadwoodRip.xBetController = new XBetController();
        DeadwoodRip.waysWon = new WaysWonCountUp();
        DeadwoodRip.initialCountUp = new InitialWinCountUp();
        DeadwoodRip.bigWinCountUp = new BigWinCountUp();
        DeadwoodRip.freespinIntro = new FreespinIntro();
        DeadwoodRip.freespinOutro = new FreespinOutro();
        DeadwoodRip.winCapScreen = new WinCapScreen();
        DeadwoodRip.nearWinView = new NearWinView();
        DeadwoodRip.reels = [
            new DeadwoodRipReelController(0),
            new DeadwoodRipReelController(1),
            new DeadwoodRipReelController(2),
            new DeadwoodRipReelController(3),
            new DeadwoodRipLastReelController()
        ];
        DeadwoodRip.reelStopPresentations = new ReelStopPresentationManager([
            new SymbolLandingController(),
            new S1LandingController(),
            new S3LandingController(),
            new SymbolWinHighlightController(),
            new ReelStopSoundController()
        ]);
        DeadwoodRip.cylinderController = new CylinderShotController();
        DeadwoodRip.winView = new WinView();
        DeadwoodRip.winPresentations = new WinPresentationManager([
            new DisableLastReelController(),
            new WildNudgeController(),
            new LowToWildController(),
            new S1ToWRSTransformController(),
            new ReelSplitController(),
            new XSplitController(),
            DeadwoodRip.cylinderController,
            new TotalMultiplierController(),
            new NoWinSymbolsController(),
            new XRipController(),
            new InitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinUpgradeController(),
            new FreespinEndController(),
            new FreespinRetriggerController(),
            new BreakBankController()
        ]);
        DeadwoodRip.individualWin = new IndividualWinController();
        DeadwoodRip.idle = new IdleAnimationManager([
            new TumbleWeedController(),
            new MainIdleDustController()
        ]);

        DeadwoodRip.skinLogo = new SkinLogo();
    }

    private restoreKeypadWin(): void {
        if (DeadwoodRip.model.isRestore) {
            if (DeadwoodRip.model.restoredFeatureBetName && DeadwoodRip.model.restoredFeatureBetName.length > 0) {
                const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                if (!activeBetFeature) {
                    SlotGame.apiPlugin.betFeatureController.setActiveBetFeature(DeadwoodRip.model.restoredFeatureBetName);
                    const newActiveBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                    if (newActiveBetFeature) {
                        // Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():new set to api feature bet name = ${newActiveBetFeature.name}`);
                    } else {
                        // Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():fail to set api feature bet name to = ${TombstoneRip.model.restoredFeatureBetName}`);
                    }
                } else {
                    // Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():api feature bet name = ${activeBetFeature.name}`);
                }
            }
            if (DeadwoodRip.model.parsedInitData.showTotalWin) {
                SlotGame.keypadPlugin.setWin(DeadwoodRip.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
            }
        }
    }
}